const weeklyHoursEl = document.getElementById("storeTimetable");
let weeklyHours = JSON.parse(weeklyHoursEl.textContent);
weeklyHours = weeklyHours.map(item =>
  (item == null || item === "") ? "Chiuso" : item
);

const dayNames = [
  "Lunedì",
  "Martedì",
  "Mercoledì",
  "Giovedì",
  "Venerdì",
  "Sabato",
  "Domenica",
];

function parseHours(hourString) {
  const [hours, minutes] = hourString.split(".").map(Number);
  return hours * 60 + minutes;
}

function parseTimetable(timetable) {
  return timetable.map((day) => {
    if (day === "Chiuso" || day === "Closed") {
      return null;
    }

    if (day.includes("/")) {
      const [morning, afternoon] = day.split(" / ");
      const [morningStart, morningEnd] = morning.split("-");
      const [afternoonStart, afternoonEnd] = afternoon.split("-");

      return {
        morning: { start: morningStart, end: morningEnd },
        afternoon: { start: afternoonStart, end: afternoonEnd },
      };
    } else {
      const [opening, closing] = day.split("-");
      openingHr = parseInt(opening.split(":")[0]);
      if (openingHr < 13) {
        const [morningStart, morningEnd] = [opening, closing];
        return {
          morning: { start: morningStart, end: morningEnd },
        };
      } else {
        const [afternoonStart, afternoonEnd] = [opening, closing];
        return {
          afternoon: { start: afternoonStart, end: afternoonEnd },
        };
      }
    }
  });
}

function timeToMinutes(time) {
  const [hour, minute] = time.split(".").map(Number);
  return hour * 60 + minute;
}

function isShopOpen(parsedTimetable) {
  const currentDay = new Date().getDay();
  const adjustedDay = currentDay === 0 ? 6 : currentDay - 1; // Adjusting to match the given timetable's order
  const todayHours = parsedTimetable[adjustedDay];

  if (!todayHours || !parsedTimetable) {
    return { isOpen: false };
  }

  const now = new Date();
  const currentDayIndex = (now.getDay() + 6) % 7;

  //   const currentTimeInMinutes = (20 * 60) + now.getMinutes();
  const currentTimeInMinutes = now.getHours() * 60 + now.getMinutes();

  const morningStart = todayHours.morning
    ? timeToMinutes(todayHours.morning.start)
    : null;
  const morningEnd = todayHours.morning
    ? timeToMinutes(todayHours.morning.end)
    : null;
  const afternoonStart = todayHours.afternoon
    ? timeToMinutes(todayHours.afternoon.start)
    : null;
  const afternoonEnd = todayHours.afternoon
    ? timeToMinutes(todayHours.afternoon.end)
    : null;

  if (
    todayHours.morning &&
    currentTimeInMinutes >= morningStart &&
    currentTimeInMinutes < morningEnd
  ) {
    return { isOpen: true, nextEvent: todayHours.morning.end };
  } else if (
    todayHours.afternoon &&
    currentTimeInMinutes >= afternoonStart &&
    currentTimeInMinutes < afternoonEnd
  ) {
    return { isOpen: true, nextEvent: todayHours.afternoon.end };
  } else if (todayHours.morning && currentTimeInMinutes < morningStart) {
    return { isOpen: false, nextEvent: todayHours.morning.start };
  } else if (todayHours.afternoon && currentTimeInMinutes < afternoonStart) {
    return { isOpen: false, nextEvent: todayHours.afternoon.start };
  }

  return { isOpen: false }; // Catch
}

function getShopStatus(timetable) {
  const parsedTimetable = parseTimetable(timetable);
  if (parsedTimetable.every(day => day === null)) {
    return { isOpen: false, closedAllWeek: true };
  }
  const shopStatus = isShopOpen(parsedTimetable);
  const currentDay = new Date().getDay();
  let adjustedDay = currentDay === 0 ? 6 : currentDay - 1;

  if (shopStatus.isOpen) {
    return {
      isOpen: true,
      closesAt: shopStatus.nextEvent,
      currentDay: adjustedDay,
    };
  } else {
    if (shopStatus.nextEvent) {
      return {
        isOpen: false,
        opensAt: shopStatus.nextEvent,
        currentDay: adjustedDay,
      };
    } else {
      // Finding the next opening day/time

      let nextDay = (adjustedDay + 1) % 7;
      while (!parsedTimetable[nextDay]) {
        nextDay = (nextDay + 1) % 7;
      }
      return {
        isOpen: false,
        opensAt: parsedTimetable[nextDay].morning.start,
        currentDay: adjustedDay,
        nextDay: dayNames[nextDay],
      };
    }
  }
}

// Remove element

function removeElement(selector) {
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    element.remove();
  });
}

// Write into element
function fillElement(selector, content) {
  const elements = document.querySelectorAll(selector);

  elements.forEach((element) => {
    element.innerHTML += content;
  });
}

function boldNthElement(selector, n) {
  const elements = Array.from(document.querySelectorAll(selector));
  if (!elements || !elements[n] || elements.length === 0) return;
  elements[n].style.fontWeight = "600";
}

//   -----------------------------------

const shopStatus = getShopStatus(weeklyHours);

if (shopStatus.closedAllWeek) {
  removeElement(".dor-store-open");
  removeElement(".dor-store-opening");
  removeElement(".dor-store-opening_time");
}
if (shopStatus.isOpen == true) {
  removeElement(".dor-store-closed");
  fillElement(".dor-store-closing_time", shopStatus.closesAt);
} else if (shopStatus.isOpen == false) {
  removeElement(".dor-store-open");
  fillElement(".dor-store-opening_time", shopStatus.opensAt);
}
boldNthElement(".store_time", shopStatus.currentDay);
